import { render, staticRenderFns } from "./AddIrDevice.vue?vue&type=template&id=31cbcee0"
import script from "./AddIrDevice.vue?vue&type=script&lang=js"
export * from "./AddIrDevice.vue?vue&type=script&lang=js"
import style0 from "./AddIrDevice.vue?vue&type=style&index=0&id=31cbcee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports